export default "__VITE_ASSET__Bpd3c8bn__"